const environments = {
    development: {
        // 开发1环境
        // baseURL: 'http://192.168.1.177:1211',
        // uploadBaseUrl: 'http://192.168.1.177:1211/upload/single',
        // fddUploadBaseUrl: 'http://192.168.1.177:1211/upload/single/fdd',
        // multiUploadBaseUrl: "http://192.168.1.177:1211/upload/batch",
        // fileUrl: 'https://img2.9000ji.com',
         
        // baseURL: 'http://192.168.1.19:1211',
        // uploadBaseUrl: 'http://192.168.1.19:1211/upload/single',
        // fddUploadBaseUrl: 'http://192.168.1.19:1211/upload/single/fdd',
        // multiUploadBaseUrl: "http://192.168.1.19:1211/upload/batch",
        // fileUrl: 'https://img2.9000ji.com',

        // //测试2
        // baseURL: 'http://192.168.1.183:1211',
        // uploadBaseUrl: 'http://192.168.1.183:1211/upload/single',
        // fddUploadBaseUrl: 'http://192.168.1.183:1211/upload/single/fdd',
        // multiUploadBaseUrl: "http://192.168.1.183:1211/upload/batch",
        // fileUrl: 'https://img2.9000ji.com',

        //测试1环境
        // baseURL: 'https://gatewayt5.fanxingtiaodong.cn',
        // uploadBaseUrl: 'https://gatewayt5.fanxingtiaodong.cn/upload/single',
        // fddUploadBaseUrl: 'https://gatewayt5.fanxingtiaodong.cn/upload/single/fdd',
        // multiUploadBaseUrl: "https://gatewayt5.fanxingtiaodong.cn/upload/batch",
        // fileUrl: 'https://img2.9000ji.com'

        // baseURL: 'http://pregateway.fanxingtiaodong.com',
        // uploadBaseUrl: 'http://pregateway.fanxingtiaodong.com/upload/single',
        // fddUploadBaseUrl: 'http://pregateway.fanxingtiaodong.com/upload/single/fdd',
        // multiUploadBaseUrl: "http://pregateway.fanxingtiaodong.com/upload/batch",
        // fileUrl: 'https://img2.9000ji.com'
        baseURL: 'https://gatewayt5.fanxingtiaodong.cn',
        uploadBaseUrl: 'https://gatewayt5.fanxingtiaodong.cn/upload/single',
        fddUploadBaseUrl: 'https://gatewayt5.fanxingtiaodong.cn/upload/single/fdd',
        multiUploadBaseUrl: "https://gatewayt5.fanxingtiaodong.cn/upload/batch",
        fileUrl: 'https://img2.9000ji.com'
        
        // baseURL: 'https://gateway.xylbh.cn',
        // uploadBaseUrl: 'https://gateway.xylbh.cn/upload/single',
        // fddUploadBaseUrl: 'https://gateway.xylbh.cn/upload/single/fdd',
        // multiUploadBaseUrl: "https://gateway.xylbh.cn/upload/batch",
        // fileUrl: 'https://img2.9000ji.com'
        

    },
    // 开发2环境
    developmentTwo: {
        baseURL: 'http://192.168.1.19:1211',
        uploadBaseUrl: 'http://192.168.1.19:1211/upload/single',
        fddUploadBaseUrl: 'http://192.168.1.19:1211/upload/single/fdd',
        multiUploadBaseUrl: "http://192.168.1.19:1211/upload/batch",
        fileUrl: 'https://img2.9000ji.com',
    },
    testing: {
        baseURL: 'http://192.168.1.177:1211',
        uploadBaseUrl: 'http://192.168.1.177:1211/upload/single',
        fddUploadBaseUrl: 'http://192.168.1.177:1211/upload/single/fdd',
        multiUploadBaseUrl: "http://192.168.1.177:1211/upload/batch",
        fileUrl: 'https://img2.9000ji.com',
    },
    
    testingtwo: {
        baseURL: 'http://192.168.1.183:1211',
        uploadBaseUrl: 'http://192.168.1.183:1211/upload/single',
        fddUploadBaseUrl: 'http://192.168.1.183:1211/upload/single/fdd',
        multiUploadBaseUrl: "http://192.168.1.183:1211/upload/batch",
        fileUrl: 'https://img2.9000ji.com',
    },
    //测试1环境
    testingOne: {
        baseURL: 'https://gatewayt5.fanxingtiaodong.cn',
        uploadBaseUrl: 'https://gatewayt5.fanxingtiaodong.cn/upload/single',
        fddUploadBaseUrl: 'https://gatewayt5.fanxingtiaodong.cn/upload/single/fdd',
        multiUploadBaseUrl: "https://gatewayt5.fanxingtiaodong.cn/upload/batch",
        fileUrl: 'https://img2.9000ji.com'
    },
    //预发布
    prerelease: {
        baseURL: 'http://pregateway.fanxingtiaodong.com',
        uploadBaseUrl: 'http://pregateway.fanxingtiaodong.com/upload/single',
        fddUploadBaseUrl: 'http://pregateway.fanxingtiaodong.com/upload/single/fdd',
        multiUploadBaseUrl: "http://pregateway.fanxingtiaodong.com/upload/batch",
        fileUrl: 'https://img2.9000ji.com'
    },
    //线上
    production: {
        baseURL: 'https://gateway.xylbh.cn',
        uploadBaseUrl: 'https://gateway.xylbh.cn/upload/single',
        fddUploadBaseUrl: 'https://gateway.xylbh.cn/upload/single/fdd',
        multiUploadBaseUrl: "https://gateway.xylbh.cn/upload/batch",
        fileUrl: 'https://img2.9000ji.com'
    }
};
export default environments

